const { Core, Events, Utils } = Global;
const { $state } = Utils;
const PREFIX_BUY_WITH = 'buy_with_' 

customElements.define('product-form', class extends Core {
    propTypes = {
        'multiple-products': Boolean
    }

    elements = {
        toCartButton: 'product-to-cart',
        form: '[data-type=add-to-cart-form]'
    }

    render() {
        this.sub(Events.CART_UPDATE, this._completeSubmit, { global: true });
        this.sub(Events.CART_ERROR, this._completeSubmit, { global: true });
        this.$('form', {
            submit: this._submitHandler
        });
    }

    _submitHandler(e) {
        e.preventDefault();
        if (this.submitting) return;
        const toCartButton = this.$('toCartButton');
        const submitButton = toCartButton?.querySelector('[data-element="to-cart-button"]');
        if (!submitButton || submitButton.matches(':disabled')) return;
        this.submitting = true;
        toCartButton.loading = true;
        this._validateForm();
        this.prop('multiple-products')
            ? toCartButton.addToCart(this.cartItems)
            : this.pub(Events.PRODUCT_FORM_SUBMIT, {
                formData: this.formData
              });

    }
    _completeSubmit() {
        this.submitting = false;
        const toCartButton = this.$('toCartButton');
        if (toCartButton?.querySelector('[data-element="to-cart-button"]')) {
            toCartButton.loading = false;
        }
    }

    // To prevent send empty form fields
    _validateForm() {
        this.formData = this._getFormData();

        for (const [key, value] of [...this.formData.entries()]) {
            if (typeof value === 'string' && value.trim() === "") this.formData.delete(key);
        }
    }

    _isVariantInput([ inputName ]) {
        return inputName.includes(PREFIX_BUY_WITH) || inputName === 'id';
    }

    _setCartItem([ _, value ]) {
        return {
            id: value,
            quantity: 1
        }
    }

    _getFormData() {
        return new FormData(this.$('form'));
    }

    get cartItems() {
        return Array.from(this.formData.entries())
            .filter(this._isVariantInput.bind(this))
            .map(this._setCartItem.bind(this))
    }
})